import { useEffect } from 'react';
import { Callback } from '../domain';

type CustomCurrency = {
  data: {
    event: string;
    namespace: string;
    data: {
      currency: string;
    };
  };
};

function isCustomCurrencyEvent(message: CustomCurrency) {
  return (
    message.data &&
    message.data.event === 'customGBEvent' &&
    message.data.namespace === 'customConversionGBEvent'
  );
}

export function useEventBasedCurrencyConverter(cb: Callback<string>) {
  useEffect(() => {
    const currencyConverterHandler = (message: CustomCurrency) => {
      if (isCustomCurrencyEvent(message)) {
        const { currency } = message.data.data;
        cb(currency);
      }
    };
    window.addEventListener('message', currencyConverterHandler);
    return () => {
      window.removeEventListener('message', currencyConverterHandler);
    };
  }, [cb]);
}

export default useEventBasedCurrencyConverter;
